const getEnvValue = (
  myKantarEnvKey: string,
  storageEnvKey: string,
  defaultValue: string,
): string => {
  if (
    typeof window !== 'undefined' &&
    window &&
    (window as any).StorageUIConfig &&
    (window as any).StorageUIConfig[myKantarEnvKey]
  ) {
    return (window as any).StorageUIConfig[myKantarEnvKey];
  }
  return process.env[storageEnvKey] || defaultValue;
};

const getBooleanEnvValue = (
  myKantarEnvKey: string,
  storageEnvKey: string,
  defaultValue: boolean,
): boolean => {
  const stringValue = getEnvValue(
    myKantarEnvKey,
    storageEnvKey,
    String(defaultValue),
  );
  return stringValue.toLowerCase() === 'true';
};

export const Constants = {
  get AZURE_CLIENT_ID() {
    return getEnvValue('azureAppId', 'VITE_APP_AZURE_APP_ID', '');
  },
  get AUTH_AUTHORITY() {
    return `https://login.microsoftonline.com/${getEnvValue('tenantId', 'VITE_APP_TENANT_ID', '')}`;
  },
  get VITE_APP_API_URL() {
    return getEnvValue(
      'apiUrl',
      'VITE_APP_API_URL',
      'https://localhost:7172/v1',
    );
  },
  get VITE_APP_API_SCOPES() {
    return getEnvValue('apiScopes', 'VITE_APP_API_SCOPES', '');
  },
  get VITE_APP_CONTAINER_PAGE_SIZE() {
    return getEnvValue('containerPageSize', 'VITE_APP_CONTAINER_PAGE_SIZE', '18');
  },
  get VITE_APP_WEBCOMPONENT_ORIGINS() {
    return getEnvValue('trustedWebComponentOrigins', '', '');
  },
  get IS_WEBCOMPONENT() {
    return this.VITE_APP_WEBCOMPONENT_ORIGINS.split(',').includes(
      window.location.origin,
    );
  },
  get WEB_COMPONENT_AUTH_TOKEN_NAME() {
    return getEnvValue('webComponentAuthTokenName', '', '');
  },

  get CLARITY_PROJECT_ID() {
    return getEnvValue(
      'clarityProjectId',
      'VITE_APP_CLARITY_PROJECT_ID',
      'scoq507qbo',
    );
  },

  get KAIA_BANNER_BUTTON_LINK() {
    return getEnvValue(
      'kaiaBannerButtonLink',
      'VITE_APP_KAIA_BANNER_BUTTON_LINK',
      'https://kaiaforinspiration.kantarmarketplace.com/',
    );
  },

  get KAIA_BANNER_CONTACT_FORM_LINK() {
    return getEnvValue(
      'kaiaBannerContactFormLink',
      'VITE_APP_KAIA_BANNER_CONTACT_FORM_LINK',
      'https://go.kantarmarketplace.com/l/73302/2025-11-18/2chk81y',
    );
  },

  get FEATURE_FLAGS() {
    const env = process.env.NODE_ENV || 'development';
    return {
      CLARITY_ENABLED: getBooleanEnvValue(
        'clarityEnabled',
        'VITE_APP_FEATURE_CLARITY_ENABLED',
        env !== 'development',
      ),
      CLARITY_DEBUG: getBooleanEnvValue(
        'clarityDebug',
        'VITE_APP_FEATURE_CLARITY_DEBUG',
        env === 'development',
      ),
      KAIA_ENABLED: getBooleanEnvValue(
        'kaiaEnabled',
        'VITE_KAIA_ENABLED',
        false,
      ),
    };
  },

  isFeatureEnabled(featureName: 'CLARITY_ENABLED' | 'CLARITY_DEBUG' | 'KAIA_ENABLED'): boolean {
    return this.FEATURE_FLAGS[featureName] === true;
  },

  kaiaContactFormIframeTitle: 'KAiA contact form',
};
